"turbolinks:load ajax:complete".split(" ").forEach(function(e){
  document.addEventListener(e, function() {
    if (typeof a2a !== 'undefined') {
      a2a.init('page');
    }
  });
});